import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material';

import { oAuth } from '../providers/oAuth';
import { Pharmacies } from '../dataObjects/Pharmacies';
import { Report, RXFilter, RxqOneRXReportRequest } from '../dataObjects/ReportCenter';
import { Doctor, ParameterStore, Queue, PriceFormula, Drug, Agency, NursingHome } from '../dataObjects/Customer';
import { DoctorSearchComponent } from '../common/doctor-search/doctor-search.component';
import { PriceFormulaSearchComponent } from '../common/price-formula-search/price-formula-search.component';
import { DrugSearchComponent } from '../common/drug-search/drug-search.component';
import { AgencySearchComponent } from '../common/agency-search/agency-search.component';


import { GlobalVariable } from '../common/global';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource } from '@angular/material';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-rx-filter',
  templateUrl: './rx-filter.component.html',
  styleUrls: ['./rx-filter.component.css']
})
export class RxFilterComponent implements OnInit {

  RXFilter: RXFilter;
  PharmaciesSelectedValue: string
  panelOpenState: boolean

  cbOptionsDrugSchedule: any;
  cbOptions340b: any;
  cbOptionsBrandGeneric: any;
  cbOptionsStates: any;
  cbOptionsCompounds: any;
  cbOptionsCheckedout: any;

  AllStores: [ParameterStore];
  AllQueues: [Queue];
  AllNursingHomes: [NursingHome];

  SelectedDoctor: Doctor;
  SelectedPriceFormula: PriceFormula;
  SelectedDrug: Drug;
  SelectedDrugs: Drug[]
  SelectedAgency: Agency;
  SelectedAgencies: Agency[]

  selectedReport: Report;
  pharms: Pharmacies[];
  opened: boolean = true;
  Reportreturnimage: string;
  ReportOptionValue: number;
  selectedIndex: any;
  loading: boolean;
  ReportOptionDD: any;

  constructor(private http: HttpClient, public snackBar: MatSnackBar, public dialog: MatDialog, public dialogRef: MatDialogRef<boolean>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.PharmaciesSelectedValue = this.data.pharm;
    this.RXFilter = this.data.RXFilter;
    this.RXFilter.RunReport = false;

    this.SelectedAgencies = [];
    this.SelectedDrugs = [];
    this.selectedReport = this.data.selectedReport;
    this.pharms = this.data.pharms;
    this.panelOpenState = true;

    this.ReportOptionDD = [
      { value: '1', viewValue: 'PDF' },
      { value: '2', viewValue: 'JPEG' },
      { value: '3', viewValue: 'CSV' }
    ]

    this.cbOptionsDrugSchedule = [
      { value: 'Any', viewValue: 'Any' },
      { value: 'Non-Scheduled', viewValue: 'Non-Scheduled' },
      { value: '2-5', viewValue: '2-5' },
      { value: '2', viewValue: '2' },
      { value: '3', viewValue: '3' },
      { value: '4', viewValue: '4' },
      { value: '5', viewValue: '5' }
    ]

    this.cbOptions340b = [
      { value: 'ALL', viewValue: 'All' },
      { value: '340B', viewValue: '340B' },
      { value: 'Non-340B', viewValue: 'Non-340B' }
    ]

    this.cbOptionsBrandGeneric = [
      { value: 'Both', viewValue: 'Both' },
      { value: 'Brand Only', viewValue: 'Brand Only' },
      { value: 'Generic Only', viewValue: 'Generic Only' }
    ]

    this.cbOptionsCompounds = [
      { value: 'ALL', viewValue: 'All' },
      { value: 'Compounds Only', viewValue: 'Compounds Only' },
      { value: 'Exclude Compounds', viewValue: 'Exclude Compounds' }
    ]

    this.cbOptionsStates = [
      { value: 'ALL', viewValue: 'All' },
      { value: 'AK-ALASKA', viewValue: 'AK-ALASKA' },
      { value: 'AL- ALABAMA', viewValue: 'AL- ALABAMA' },
      { value: 'AR-ARKANSAS', viewValue: 'AR-ARKANSAS' },
      { value: 'AS-AMERICAN SAMOA', viewValue: 'AS-AMERICAN SAMOA' },
      { value: 'AZ-ARIZONA', viewValue: 'AZ-ARIZONA' },
      { value: 'CA-CALIFORNIA', viewValue: 'CA-CALIFORNIA' },
      { value: 'CO-COLORADO', viewValue: 'CO-COLORADO' },
      { value: 'CT-CONNECTICUT', viewValue: 'CT-CONNECTICUT' },
      { value: 'DC-DISTRICT OF COLUMBIA', viewValue: 'DC-DISTRICT OF COLUMBIA' },
      { value: 'DC-WASHINGTON, DC', viewValue: 'DC-WASHINGTON, DC' },
      { value: 'DE-DELAWARE', viewValue: 'DE-DELAWARE' },
      { value: 'FL-FLORIDA', viewValue: 'FL-FLORIDA' },
      { value: 'FM-FEDERATED STATES OF MICRONESIA', viewValue: 'FM-FEDERATED STATES OF MICRONESIA' },
      { value: 'GA-GEORGIA', viewValue: 'GA-GEORGIA' },
      { value: 'GU-GUAM', viewValue: 'GU-GUAM' },
      { value: 'HI-HAWAII', viewValue: 'HI-HAWAII' },
      { value: 'IA-IOWA', viewValue: 'IA-IOWA' },
      { value: 'ID-IDAHO', viewValue: 'ID-IDAHO' },
      { value: 'IL-ILLINOIS', viewValue: 'IL-ILLINOIS' },
      { value: 'IN-INDIANA', viewValue: 'IN-INDIANA' },
      { value: 'KS-KANSAS', viewValue: 'KS-KANSAS' },
      { value: 'KY-KENTUCKY', viewValue: 'KY-KENTUCKY' },
      { value: 'LA-LOUISIANA', viewValue: 'LA-LOUISIANA' },
      { value: 'MA-MASSACHUSETTS', viewValue: 'MA-MASSACHUSETTS' },
      { value: 'MD-MARYLAND', viewValue: 'MD-MARYLAND' },
      { value: 'ME-MAINE', viewValue: 'ME-MAINE' },
      { value: 'MH-MARSHALL ISLANDS', viewValue: 'MH-MARSHALL ISLANDS' },
      { value: 'MI-MICHIGAN', viewValue: 'MI-MICHIGAN' },
      { value: 'MN-MINNESOTA', viewValue: 'MN-MINNESOTA' },
      { value: 'MO-MISSOURI', viewValue: 'MO-MISSOURI' },
      { value: 'MP-NORTHERN MARIANA ISLANDS', viewValue: 'MP-NORTHERN MARIANA ISLANDS' },
      { value: 'MS-MISSISSIPPI', viewValue: 'MS-MISSISSIPPI' },
      { value: 'MT-MONTANA', viewValue: 'MT-MONTANA' },
      { value: 'NC-NORTH CAROLINA', viewValue: 'NC-NORTH CAROLINA' },
      { value: 'ND-NORTH DAKOTA', viewValue: 'ND-NORTH DAKOTA' },
      { value: 'NE-NEBRASKA', viewValue: 'NE-NEBRASKA' },
      { value: 'NH-NEW HAMPSHIRE', viewValue: 'NH-NEW HAMPSHIRE' },
      { value: 'NJ-NEW JERSEY', viewValue: 'NJ-NEW JERSEY' },
      { value: 'NM-NEW MEXICO', viewValue: 'NM-NEW MEXICO' },
      { value: 'NV-NEVADA', viewValue: 'NV-NEVADA' },
      { value: 'NY-NEW YORK', viewValue: 'NY-NEW YORK' },
      { value: 'OH-OHIO', viewValue: 'OH-OHIO' },
      { value: 'OK-OKLAHOMA', viewValue: 'OK-OKLAHOMA' },
      { value: 'OR-OREGON', viewValue: 'OR-OREGON' },
      { value: 'PA-PENNSYLVANIA', viewValue: 'PA-PENNSYLVANIA' },
      { value: 'PR-PUERTO RICO', viewValue: 'PR-PUERTO RICO' },
      { value: 'PW-PALAU', viewValue: 'PW-PALAU' },
      { value: 'RI-RHODE ISLAND', viewValue: 'RI-RHODE ISLAND' },
      { value: 'SC-SOUTH CAROLINA', viewValue: 'SC-SOUTH CAROLINA' },
      { value: 'SD-SOUTH DAKOTA', viewValue: 'SD-SOUTH DAKOTA' },
      { value: 'TN-TENNESSEE', viewValue: 'TN-TENNESSEE' },
      { value: 'TX-TEXAS', viewValue: 'TX-TEXAS' },
      { value: 'UT-UTAH', viewValue: 'UT-UTAH' },
      { value: 'VA-VIRGINIA', viewValue: 'VA-VIRGINIA' },
      { value: 'VI-VIRGIN ISLANDS', viewValue: 'VI-VIRGIN ISLANDS' },
      { value: 'VT-VERMONT', viewValue: 'VT-VERMONT' },
      { value: 'WA-WASHINGTON', viewValue: 'WA-WASHINGTON' },
      { value: 'WI-WISCONSIN', viewValue: 'WI-WISCONSIN' },
      { value: 'WV-WEST VIRGINIA', viewValue: 'WV-WEST VIRGINIA' },
      { value: 'WY-WYOMING', viewValue: 'WY-WYOMING' }
    ]

    this.cbOptionsCheckedout = [
      { value: 'ALL', viewValue: 'All' },
      { value: 'Prescriptions Checked Out', viewValue: 'Prescriptions Checked Out' },
      { value: 'Prescriptions NOT Checked Out', viewValue: 'Prescriptions Not Checked Out' }
      ]
  }

  PharmChanged() {
    this.PopParameterStore();
    this.PopQueues();
    this.PopNursingHomes();
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 40000,
    });
  }

  openDoctorSearchDialog(): void {
    let dialogRef = this.dialog.open(DoctorSearchComponent, {
      width: '750px',
      height: '550px',
      data: { Doctor: this.SelectedDoctor, PharmaciesSelectedValue: this.PharmaciesSelectedValue }
    });

    dialogRef.afterClosed().subscribe(result => {
      var doc = <Doctor>result;
      this.SelectedDoctor = doc;
      this.RXFilter.txtDoctor = this.SelectedDoctor.DoctorId;
    });
  }

  openDrugSearchDialog(): void {
    let dialogRef = this.dialog.open(DrugSearchComponent, {
      width: '750px',
      height: '550px',
      data: { Drug: this.SelectedDrug, Drugs: this.SelectedDrugs, PharmaciesSelectedValue: this.PharmaciesSelectedValue }
    });

    dialogRef.afterClosed().subscribe(result => {

      var DrugCodes: string[] = [];

      for (var i = 0; i < this.SelectedDrugs.length; i++) {
        DrugCodes.push(this.SelectedDrugs[i].Key)
      }

      this.RXFilter.lvDrugs = DrugCodes;
    });
  }

  openPFSearchDialog(): void {
    let dialogRef = this.dialog.open(PriceFormulaSearchComponent, {
      width: '750px',
      height: '550px',
      data: { PriceFormula: this.SelectedPriceFormula, PharmaciesSelectedValue: this.PharmaciesSelectedValue }
    });

    dialogRef.afterClosed().subscribe(result => {
      var PriceFormula = <PriceFormula>result;
      this.SelectedPriceFormula = PriceFormula;
      this.RXFilter.txtPriceFormula = this.SelectedPriceFormula.PriceFormulaCode;
    });
  }

  openInsuranceSearchDialog(): void {
    let dialogRef = this.dialog.open(AgencySearchComponent, {
      width: '750px',
      height: '550px',
      data: { Agency: this.SelectedAgency, Agencies: this.SelectedAgencies, PharmaciesSelectedValue: this.PharmaciesSelectedValue }
    });

    dialogRef.afterClosed().subscribe(result => {

      var AgencyCodes: string[] = [];

      for (var i = 0; i < this.SelectedAgencies.length; i++) {
        AgencyCodes.push(this.SelectedAgencies[i].AgencyCode)
      }

      this.RXFilter.lvAgencies = AgencyCodes;
    });
  }

  PopParameterStore() {

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    var body = JSON.stringify(this.PharmaciesSelectedValue)

    this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneGetStores", body.toString(), options)
      .subscribe(
        (response) => {
          const resp = <[ParameterStore]>response

          var AllStoreItem: ParameterStore = { StoreNumber: '00', PharmacyName: 'All Stores' };
          resp.unshift(AllStoreItem);
          this.AllStores = resp;

        },
        (err) => {
          /* this function is executed when there's an ERROR */

        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //this.openSnackBar("Set Batches has completed.", "OK");
        }
      );
  }

  PopQueues() {

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    var body = JSON.stringify(this.PharmaciesSelectedValue)

    this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneGetQueues", body.toString(), options)
      .subscribe(
        (response) => {
          const resp = <[Queue]>response
          this.AllQueues = resp;

        },
        (err) => {
          /* this function is executed when there's an ERROR */

        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //this.openSnackBar("Set Batches has completed.", "OK");
        }
      );
  }

  PopNursingHomes() {

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    var body = JSON.stringify(this.PharmaciesSelectedValue)

    this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneGetNursingHomes", body.toString(), options)
      .subscribe(
        (response) => {
          const resp = <[NursingHome]>response
          this.AllNursingHomes = resp;

        },
        (err) => {
          /* this function is executed when there's an ERROR */

        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //this.openSnackBar("Set Batches has completed.", "OK");
        }
      );
  }

  runReport() {
    this.RXFilter.RunReport = true;
    this.dialogRef.close();
  }

  closeDlg() {
    this.dialogRef.close();
  }
  setDate(date: any) {
    var s: String = date.toLocaleString();
    s = s.split(",")[0];
    return s;
  }
  RunRXReport(download: boolean) {

    window.scrollTo(0, 0);
    this.loading = true;
    this.opened = false;

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    if (download == false) {
      this.RXFilter.ReportOption = null;
      this.Reportreturnimage = null;
      this.ReportOptionValue = null;
    }

    var selectedTemplate;

    let RxqOneRXRequest: RxqOneRXReportRequest = {
      Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
      RXFilterDialogValues: this.RXFilter
    };

    RxqOneRXRequest.RXFilterDialogValues.ReportTemplate = this.selectedReport.ReportPath;
    RxqOneRXRequest.RXFilterDialogValues.ReportOption = this.ReportOptionValue;
    if (RxqOneRXRequest.RXFilterDialogValues.dtDynamicDDEndingDate) {
      RxqOneRXRequest.RXFilterDialogValues.dtDynamicDDEndingDate =this.setDate(RxqOneRXRequest.RXFilterDialogValues.dtDynamicDDEndingDate );
    }
    if (RxqOneRXRequest.RXFilterDialogValues.dtDynamicDDStartingDate) {
      RxqOneRXRequest.RXFilterDialogValues.dtDynamicDDStartingDate =this.setDate(RxqOneRXRequest.RXFilterDialogValues.dtDynamicDDStartingDate );
    }
    if (RxqOneRXRequest.RXFilterDialogValues.dtDynamicPatientAddedEnd) {
      RxqOneRXRequest.RXFilterDialogValues.dtDynamicPatientAddedEnd =this.setDate(RxqOneRXRequest.RXFilterDialogValues.dtDynamicPatientAddedEnd );
    }
    if (RxqOneRXRequest.RXFilterDialogValues.dtDynamicPatientAddedStart) {
      RxqOneRXRequest.RXFilterDialogValues.dtDynamicPatientAddedStart =this.setDate(RxqOneRXRequest.RXFilterDialogValues.dtDynamicPatientAddedStart );
    }
    if (RxqOneRXRequest.RXFilterDialogValues.dtDynamicRefillDueEnd) {
      RxqOneRXRequest.RXFilterDialogValues.dtDynamicRefillDueEnd =this.setDate(RxqOneRXRequest.RXFilterDialogValues.dtDynamicRefillDueEnd );
    }
    if (RxqOneRXRequest.RXFilterDialogValues.dtDynamicRefillDueStart) {
      RxqOneRXRequest.RXFilterDialogValues.dtDynamicRefillDueStart =this.setDate(RxqOneRXRequest.RXFilterDialogValues.dtDynamicRefillDueStart );
    }
    if (RxqOneRXRequest.RXFilterDialogValues.dtDynamicTransferredOutEnd) {
      RxqOneRXRequest.RXFilterDialogValues.dtDynamicTransferredOutEnd =this.setDate(RxqOneRXRequest.RXFilterDialogValues.dtDynamicTransferredOutEnd );
    }
    if (RxqOneRXRequest.RXFilterDialogValues.dtDynamicTransferredOutStart) {
      RxqOneRXRequest.RXFilterDialogValues.dtDynamicTransferredOutStart =this.setDate(RxqOneRXRequest.RXFilterDialogValues.dtDynamicTransferredOutStart );
    }

    if (this.PharmaciesSelectedValue.toString() == '0' && this.RXFilter.ReportOption != null) {

      var body = JSON.stringify(RxqOneRXRequest)

      this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneRxReport", body.toString(), options)
        .subscribe(
          (response) => {
            if (this.RXFilter.ReportOption == null) {
              this.Reportreturnimage = <string>response;
            }
            else {

              if (this.RXFilter.ReportOption == 1) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);


                var blob = new Blob([byteArray], { type: 'applicaton/pdf' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".pdf");

              }
              if (this.RXFilter.ReportOption == 2) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: 'image/jpg' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".jpg");

              }

              if (this.RXFilter.ReportOption == 3) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: 'text/csv' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".csv");

              }

            }
          },
          (err) => {
            /* this function is executed when there's an ERROR */

            if (err.error.includes("Record not Found")) {
              this.openSnackBar("No records found.", "Warning");
            }
            else {
              this.openSnackBar("There was an issue with this request", "Error");
            }

            this.loading = false;

          },
          () => {
            /* this function is executed when the observable ends (completes) its stream */
            this.loading = false;
            this.openSnackBar("RX has completed.", "OK");
          }
        );
    }

    else {
      var body = JSON.stringify(RxqOneRXRequest)

      this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneRxReport", body.toString(), options)
        .subscribe(
          (response) => {
            if (this.RXFilter.ReportOption == null) {
              this.Reportreturnimage = <string>response;
            }
            else {

              if (this.RXFilter.ReportOption == 1) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);


                var blob = new Blob([byteArray], { type: 'applicaton/pdf' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".pdf");

              }
              if (this.RXFilter.ReportOption == 2) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: 'image/jpg' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".jpg");

              }

              if (this.RXFilter.ReportOption == 3) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: 'text/csv' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".csv");

              }

            }
          },
          (err) => {
            /* this function is executed when there's an ERROR */

            if (err.error.includes("Record not Found")) {
              this.openSnackBar("No records found.", "Warning");
            }
            else {
              this.openSnackBar("There was an issue with this request", "Error");
            }

            this.loading = false;

          },
          () => {
            /* this function is executed when the observable ends (completes) its stream */
            this.loading = false;
            this.openSnackBar("RX has completed.", "OK");
          }
        );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/rx-filter/rx-filter.component.ts